import React, { Component } from "react";
import PropTypes from "prop-types";
import { findDOMNode } from "react-dom";

export default class TransitionChildren extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prev: props.children,
      children: props.children
    };
  }

  componentWillReceiveProps({ children }) {
    this.setState({ prev: children });
    this.node = findDOMNode(this);

    if (this.state.prev.key !== children.key) {
      console.log("Transition", this.state.prev.key, "to", children.key);
    }

    if (this.state.prev.key !== children.key) {
      this.node.classList.add(this.props.transitionClass);

      this.timeout = null;

      this.onTransitionEnd = evt => {
        if (evt.target !== this.node) {
          return;
        }
        if (this.timeout) clearTimeout(this.timeout);
        this.node.removeEventListener("transitionend", this.onTransitionEnd);
        this.setState(state => ({ children: state.prev }));
        this.node.classList.remove(this.props.transitionClass);
      };

      this.timeout = setTimeout(() => {
        console.log(
          "CSS Transition End not fired for",
          this.state.prev.key,
          "to",
          children.key
        );
        this.node.removeEventListener("transitionend", this.onTransitionEnd);
        this.setState(state => ({ children: state.prev }));
        this.node.classList.remove(this.props.transitionClass);
      }, 5000);

      this.node.addEventListener("transitionend", this.onTransitionEnd);
    } else {
      this.setState(state => ({ children: state.prev }));
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    this.node.removeEventListener("transitionend", this.onTransitionEnd);
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.state.children}
      </div>
    );
  }

  static propTypes = {
    className: PropTypes.string.isRequired,
    transitionClass: PropTypes.string.isRequired
  };
}



// WEBPACK FOOTER //
// ./src/common/TransitionChildren.js